module.exports = __webpack_public_path__ + "img/1.552e487c.png";